import { httpRequest } from "@/utils/HttpRequest";
import {
    ItemDetailed,
    MaterialDetailed,
    IMaintenanceField,
    IMaintenanceRoSettleParams,
    IMaintenanceSearch,
    IMaintenanceDetail,
    IMaintenanceRoSettleAndWhConfirm,
    IMaintenanceList,
    IPrintExcel,
    IMaintenanceStatistics
} from "./maintenanceType"

class MaintenanceService {
    async page(searchVo: IMaintenanceSearch) {
        const apiUrl = "/vrm2/maintenance/findPage";
        return await httpRequest.post<IMaintenanceList>(apiUrl, searchVo);
    }
    async total(searchVo: IMaintenanceSearch) {
        const apiUrl = "/vrm2/maintenance/total";
        return await httpRequest.post<IMaintenanceStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm2/maintenance/findById/${id}`;
        return await httpRequest.get<IMaintenanceDetail>(apiUrl, { timeout: 60000 });
    }
    async insert(insertVo: IMaintenanceField) {
        const apiUrl = "/vrm2/maintenance/insert";
        return await httpRequest.post<IMaintenanceDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IMaintenanceField) {
        const apiUrl = "/vrm2/maintenance/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    // 库房确认
    async warehousing(params: IMaintenanceRoSettleAndWhConfirm) {
        const apiUrl = "/vrm2/maintenance/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修用料明细删除
    async materialDelete(params: MaterialDetailed) {
        const apiUrl = "/vrm2/maintenance/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修项目明细删除
    async itemDelete(params: ItemDetailed) {
        const apiUrl = "/vrm2/maintenance/itemDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: IMaintenanceRoSettleParams) {
        const apiUrl = "/vrm2/maintenance/settlePro";
        // const apiUrl = "/vrm2/maintenance/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //作废
    async invalidate(params: object) {
        const apiUrl = "/vrm2/maintenance/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //重新加载维修项目得数据
    async projectQuery(params: string[]) {
        const apiUrl = "/vrm2/base/item/projectQuery";
        return await httpRequest.post<ItemDetailed[]>(apiUrl, params);
    }
    //重新加载维修用料得数据
    async find(params: string[]) {
        const apiUrl = "/vrm2/stock/find";
        return await httpRequest.post<MaterialDetailed[]>(apiUrl, params);
    }
    //预约转维修
    async transfer(params: object) {
        const apiUrl = "/vrm2/maintenance/transfer";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //转车间
    async tran(params: object) {
        const apiUrl = "/vrm2/maintenance/tran";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: IMaintenanceSearch) {
        const apiUrl = "/vrm2/maintenance/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //详情导出
    async detailsExport(params: IMaintenanceSearch) {
        const apiUrl = "/vrm2/maintenance/repairFormExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //打印Excel格式
    async excelPrint(params: IPrintExcel) {
        const apiUrl = "/vrm2/maintenance/exportFind";
        return await httpRequest.postFile(apiUrl, params);
    }
    //打印预约单Excel格式
    async appointmentExcelPrint(params: IPrintExcel) {
        const apiUrl = "/vrm2/appointment/exportFind";
        return await httpRequest.postFile(apiUrl, params);
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/vrm2/maintenance/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
    //审核接口
    async examine(params: object) {
        const apiUrl = `/vrm2/maintenance/examine`;
        return await httpRequest.post(apiUrl, params);
    }
    //审核通过接口
    async approved(params: object) {
        const apiUrl = `/vrm2/maintenance/approved`;
        return await httpRequest.post(apiUrl, params);
    }
    //维修退单审核通过
    async chargebackPassed(params: object) {
        const apiUrl = `/vrm2/maintenance/chargebackPassed`;
        return await httpRequest.post(apiUrl, params);
    }
    //维修退单待审核
    async chargebackApproval(params: object) {
        const apiUrl = `/vrm2/maintenance/chargebackApproval`;
        return await httpRequest.post(apiUrl, params);
    }

    //查询最高售价和最低售价
    async price(params: object) {
        const apiUrl = '/vrm2/sale/customerHigAndLow';
        return await httpRequest.post(apiUrl, params);
    }
}
export const maintenanceService = new MaintenanceService();
